import { Field, Form, Formik, ErrorMessage } from 'formik';
import React, { useEffect, useState,useRef } from 'react';
import Button from 'react-bootstrap/Button';
import { useSelector, useDispatch } from 'react-redux';
import { connect,  } from 'react-redux';
import { checkOutData, checkOutDataAsGuest } from "../../../services/addressService";
import { removeToCart, clearCartItem } from '../../../store/actions/cart';
import { rewards, userRewards } from "../../../services/myAccountService";
import * as actions from '../../../store/actions/cart';
import { isEmpty } from '../../../validation';
import Stepper from '../../Stepper/index';
import LoaderSpinner from "../../Loader/loaderSpinner";
import * as Yup from 'yup';
import swal from 'sweetalert';
import { addCartDevices, getCartDevices, removeCartDevices,EmptyCartDevices } from '../../../services/cartDevices';


const CheckOutPage = (props) => {
    const dispatch = useDispatch();
    const cartData = useSelector(state => state.cart);
    const [total, setTotal] = useState(0)
    const [promoCode, setPromoCode] = useState(null)
    const [promoErrorMessage, setPromoErrorMessage] = useState(null)
    const [promoSuccessMessage, setPromoSuccessMessage] = useState(null)
    const [promoCodeBonus, setPromoCodeBonus] = useState(null)
    const [isLoader, setIsLoader] = useState(false)
    const [count, setCount]= useState(1)
    const [boxes, setBoxes] = useState([]);
    

    const previousPage = () => {

        props.history.push(window.location.href="/cart/address");
    }
    
    const handleSubmit = () => {
        setIsLoader(true)
        const inPerson=props.paymentMethod.inperson?'Canpar':'local-pickup'
        const obj = {
            firstName: props.address.firstName,
            lastName: props.address.lastName,
            email: props.paymentMethod.email,
            devices: cartData.items,
            totalPayment: total,
            paymentMethod: props.paymentMethod.method,
            payment_name: props.paymentMethod.name,
            paymentUsername: props.paymentMethod.useName,
            paymentPhone: props.paymentMethod.phone,
            paymentEmail: props.paymentMethod.email,
            phoneNumber: props.paymentMethod.phone ? props.paymentMethod.phone : '',
            addressType: props.address.addType,
            addressLine1: props.address.addressLine1,
            addressLine2: props.address.addressLine2,
            city: props.address.city,
            state: props.address.state,
            zipcode: props.address.zipcode,
            deviceShippingMethod:inPerson
        }
        if (props.token) {
            checkOutData(obj).then(
              
                (res) => {
                   
                setIsLoader(false)
                dispatch(clearCartItem())
                localStorage.removeItem("CartItems")
                EmptyCartDevices().then((res)=>{
                    if(res.data){
                        console.log(res)
                       
                    }
                }).catch((err)=>{
                    console.log(err)})
                    window.location.href="/check-out-success";
               

                    
                }
            ).catch(err => {
                console.log(err);
                if(err){
                    
                    window.location.href="/check-out-failed";
                }
            })
        } else {
            const data = {
                firstName: props.address.firstName,
                lastName: props.address.lastName,
                email: props.paymentMethod.email,
                devices: cartData.items,
                totalPayment: total,
                paymentMethod: props.paymentMethod.method,
                payment_name: props.paymentMethod.name,
                paymentUsername: props.paymentMethod.useName,
                paymentPhone: props.paymentMethod.phone,
                paymentEmail: props.paymentMethod.email,
                phoneNumber: props.paymentMethod.phone ? props.paymentMethod.phone : '',
                addressType: props.address.addType,
                addressLine1: props.address.addressLine1,
                addressLine2: props.address.addressLine2,
                city: props.address.city,
                state: props.address.state,
                zipcode: props.address.zipcode,
                deviceShippingMethod:inPerson
               
            }
            console.log(data)
            checkOutDataAsGuest(data).then(
                (res) => {
                    window.location.href="/check-out-success";
                    props.clearCart();
                }
            ).catch(err => {
                console.log(err);
                if(err){
                    window.location.href="/check-out-failed";
                }
                
            })
        }
    };
    const validation=
        Yup.object().shape({
            tandc:Yup.boolean()
            .oneOf([true], "You must accept the terms and conditions to submit the order")
            
        });
    
    const removeCartById = (id) => {
            swal({
                title: "Are you sure?",
                text: "Want to delete this item from the box",
                icon: "warning",
                buttons: true,
                dangerMode: true,
              })
              .then((willDelete)=>{
                if(willDelete){
                    dispatch(removeToCart(id))
                    removeCartDevices(id).then((res)=>{
                        if(res){
                            console.log(res)
                            localStorage.removeItem('CartItems')
                            window.location.reload()
                        }
    
                    }).catch(err=>{
                        console.log(err)
                    })
                }})   
        }
    
    const EmptyCart = () => {
            swal({
                title: "Are you sure?",
                text: "Want to delete all item from the box",
                icon: "warning",
                buttons: true,
                dangerMode: true,
              })
              .then((willDelete)=>{
                if(willDelete){
                    dispatch(clearCartItem())
                    localStorage.removeItem("CartItems")
                EmptyCartDevices().then((res)=>{
                    if(res.data){
                        console.log(res)
                        
                        window.location.reload()
                    }
                }).catch((err)=>{
                    console.log(err)})
                    
                    
                   
                }})
    
              
           
        }
    function handleChange(e) {

        // Destructure the children from the parent of
        // the element that was changed (ie all the input elements)
        const { parentNode: { children } } = e.target;
    
        // Find the index of the box that was changed
        const index = [...children].indexOf(e.target);
    
        // Copy the state
        const newState = [...boxes];
    
        // Toggle the boolean at the index of
        // the `newState` array
        newState[index] = !newState[index];
    
        // Set the state with the updated array
        setBoxes(newState);
      }
    
      // `filter` the boxes that return true.
      // Return true if the length is 0 or > 1.
      function isDisabled() {
        const len = boxes.filter(box => box).length;
        return len === 0 || len > 1;
      }
    const applyPromoCode = () => {
        if (promoCode) {
            const obj = {
                promocode: promoCode
            };
            rewards(obj).then(
                (res) => {
                    if (!isEmpty(res.data.results)) {
                        const bonus = res.data.results[0].bonus.replace('$', '')
                        setPromoCodeBonus(parseInt(bonus))
                        if (isEmpty(res.data.results[0].condition)) {
                            const finalTotal = total + parseInt(bonus)
                            setTotal(finalTotal)
                            setPromoSuccessMessage(`Promo code ${promoCode} applied`)
                        } else {
                            const error = [];
                            const condition = res.data.results[0].condition
                            if (condition.includes('cartValue=>$100')) {
                                if (total > 100) { } else {
                                    error.push('Cart value should be minimum $100')
                                }
                            }
                            if (condition.includes('registerUserOnly')) {
                                if (props.token) {
                                    const userRewardsObj = {
                                        id: localStorage.getItem('UserId'),
                                        promocode: res.data.results[0].id
                                    }
                                    userRewards(userRewardsObj).then(
                                        (response) => {
                                            if (!isEmpty(response.data.results[0].promocode)) {
                                                const finalTotal = total + parseInt(bonus)
                                                setTotal(finalTotal)
                                                setPromoSuccessMessage(`Promo code ${promoCode} applied`)
                                            } else {
                                                error.push('Invalid promo code')
                                            }
                                        })
                                } else {
                                    error.push('Please login or register to avail this promo code')
                                }
                            }

                            if (!error.length) {
                                const finalTotal = total + parseInt(bonus)
                                setTotal(finalTotal)
                                setPromoSuccessMessage(`Promo code ${promoCode} applied`)
                            } else {
                                setPromoErrorMessage(error[0])
                            }

                        }
                    }
                }
            ).catch(err => {
                console.log(err);
            })
        }
    }

    useEffect(() => {
        var total = cartData && cartData.items.length &&
            cartData.items.reduce((a, { deviceOffer }) => a + parseInt(deviceOffer), 0) || 0
        setTotal(total)
    }, [cartData])

    useEffect(() => {
        if (isEmpty(props.items)) {
            props.history.push("/cart");
        }
    });
    
    const section1Ref=useRef()
            const scrollToSection = (ref) => {
                ref.current?.scrollIntoView({ behavior: "smooth", block: "center" });
        };
    const useWindowWidth = () => {
            const [windowWidth, setWindowWidth] = useState(window.innerWidth);
          
            useEffect(() => {
              const handleResize = () => setWindowWidth(window.innerWidth);
              window.addEventListener('resize', handleResize);
          
              return () => window.removeEventListener('resize', handleResize);
            }, []);
          
            return windowWidth;
          };
          
    const windowWidth = useWindowWidth();
    return (
        <div>
            <div>
                {
                    props.totalPayment >= 1 &&
                    <Stepper steps={[{ title: "Cart" }, { title: "Payment" }, { title: "Address" }, { title: "Checkout" }]} activeStep={3} />
                }
                {
                    props.totalPayment === 0 &&
                    <Stepper steps={[{ title: "Cart" }, { title: "Address" }, { title: "Checkout" }]} activeStep={2} />
                }
            </div>
            <hr></hr>
        <div className='container'>
            <div>
            <button className='text-dark h4 border-dark-white rounded-bottom   my-2 w-100'>
               Your Box
            </button>
            
           
            <div className='container-3'>
            {
             !isEmpty(cartData.items) &&
             <Button className="my-2 mx-2" variant="outline-danger rounded-lg" onClick={() => EmptyCart()}>
                <strong className=''> Empty Box </strong>
            </Button>
            }
              {!isEmpty(cartData.items)&&windowWidth < 768 && cartData.items.length>3&&
          
          <Button className="w-100 border-dark" onClick={()=>scrollToSection(section1Ref)} ><strong className='text-dark'>Checkout </strong></Button>
            }
            <Formik
                initialValues={{ method: props.paymentMethod.method ? props.paymentMethod.method : '',
                                tandc:false }}
                onSubmit={handleSubmit}
                validationSchema={validation}
            >
                {({ isSubmitting, values }) => (
                    <Form>
                        <div className="">
                            {
                               !isEmpty(cartData.items) && cartData.items.map((item, index) => (
                                                   <div className="" key={index} >
                                                      
                                                       
                                                      <div className='p-2 ml-2'>
                                                      <div className='d-flex item-3'>
                                                            <div className='bg-gren w-50'>
                                                                <div className=''>
                                                                <div>
                                                                <img className="w-50 h-25 bg-white" src={item.deviceImages} /> 
                                                            </div>
                                                            <div className="ml-2"style={{fontSize:12, fontWeight:'bold'}}>
                                                            {item.deviceModel}
                                                            </div>
                                                       
                                                        <div className=''>
                                                        {item.deviceOffer === 0 &&
                                                            <button className="rounded-lg mt-1 bg-green w-100 p-2" style={{ fontSize:12, }}  > <strong>Recycling...</strong></button>
                                                        }
                                                        {item.deviceOffer != 0 &&
                                                            <button className="rounded-lg mt-1 bg-warning w-100 p-2" style={{ fontSize: 12, color:'black' }}  > <strong>Today's offer: ${item.deviceOffer}</strong></button>
                                                        }
                                                        </div> 
                                                        </div>
                                                        </div>
                                                        <div className='bg- e w-50'>
                                                        <div className=" ">
                                                            {item.deviceCapacity&&
                                                               <>
                                                               <button className='rounded bg-white ml-2 border border-dark' style={{fontSize:12, color:'black'}}>
                                                                {item.deviceCapacity}  </button>
                                                               <br></br>
                                                               </>
                                                               
                                                                    }
                                                            {item.deviceRAM&&
                                                               <>
                                                               <button className='rounded bg-white ml-2 border border-dark' style={{fontSize:12, color:'black'}}>
                                                                {item.deviceRAM}  </button>
                                                               <br></br>
                                                               </>
                                                               
                                                                } 
                                                            {item.deviceGeneration&&
                                                            <>
                                                            <button className='rounded mt-1 bg-white border border-dark  ml-2' style={{fontSize:12, color:'black'}}> 
                                                                
                                                                {item.deviceGeneration}
                                                                </button> 
                                                                <br></br>
                                                                </>
                                                                    }
                                                                      
                                                            {item.deviceType&&
                                                            <>
                                                            <button className='rounded mt-1  bg-white border border-dark ml-2' style={{fontSize:12, color:'black'}}> 
                                                                 {item.deviceType}
                                                                </button> 
                                                                <br></br></>
                                                            
                                                            }
                                                             {item.deviceCarrier&&item.deviceCarrier!=0&&
                                                                 <>
                                                                  <button className='rounded mt-1 border bg-white border-dark  ml-2' style={{fontSize:12, color:'black'}}> 
                                                                    {item.deviceCarrier}
                                                                    </button> 
                                                                    <br></br>
                                                                    </>
                                                              
                                                            }
                                                            {item.deviceYear&&
                                                            <>
                                                            <button className='rounded bg-white mt-1  border border-dark  ml-2' style={{fontSize:12,color:'black'}}> 
                                                                {item.deviceYear}
                                                                </button> 
                                                                 <br></br></>
                                                            
                                                            }
                                                            {item.deviceProcessor&&
                                                            <>
                                                             <button  className='rounded bg-white mt-1 border-dark  ml-2' style={{fontSize:12,color:'black'}}> 
                                                                {item.deviceProcessor}
                                                                </button> 
                                                                <br></br></>
                                                           
                                                            }
                                                              
                                                        
                                                              {item.deviceSize && item.deviceSize!=0 &&
                                                            <>
                                                            <button className="rounded bg-white  mt-1   border border-dark  ml-2" style={{ fontSize: 12, color:'black' }}>
                                                                {item.deviceSize}
                                                            </button>
                                                            <br />
                                                            </>
                                                            }
                                                        {item.deviceEdition &&item.deviceEdition!=0&& 
                                                            <>
                                                            <button className="rounded bg-white mt-1   border border-dark ml-2" style={{ fontSize: 12, color:'black' }}>
                                                               {item.deviceEdition}
                                                            </button>
                                                            <br />
                                                            </>
                                                        }
                                                        {item.deviceBand &&item.deviceBand !=0 &&
                                                            <>
                                                            <button className="rounded bg-white mt-1 border  border-dark  ml-2" style={{ fontSize: 12, color:'black' }}>
                                                               {item.deviceBand}
                                                            </button>
                                                            <br />
                                                            </>
                                                        }
                                                        
                                                        {item.deviceBand && (
                                                            <>
                                                            <button className="rounded bg-white mt-1  border border-dark  ml-2" style={{ fontSize: 12, color:'black' }}>
                                                            
                                                            {item.deviceCondition}
                                                            </button>
                                                            <br />
                                                            </>
                                                            
                                                        
                                                        )}
                                                       </div> 
                                                    </div>
                                     
                                                       <div className=''> 
                                                           <span className="float-right text-danger cursor-pointer" onClick={() => removeCartById(item.deviceId)}><svg width="1.5em" height="1.5em" viewBox="0 0 16 16" className="bi bi-trash" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                                               <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6z" />
                                                               <path fill-rule="evenodd" d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1zM4.118 4L4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118zM2.5 3V2h11v1h-11z" />
                                                           </svg></span>  
                                                       </div>    
                                                    </div>
                                                           </div>                       
                                                           
                                                          
                                                        
                                                   
                                                       
                                                       </div>
                                                       
                                               ))
                            }
                           
                        <div className='item-3 d-flex ml-2_5' >
                          
                            <div className='p-2'>
                                <div>
                                     <label className=""><strong>Name:</strong><br></br>
                                     <span className='text-black'> {cartData && cartData.address.firstName} {cartData && cartData.address.lastName}</span></label> 
                                </div>
                              
                            
                         
                                {cartData && cartData.address &&
                                <>
                                    <div className="p-2  border border-white-dark rounded w-100">
                                        <lable style={{fontSize:14}}> <strong>Address :</strong> <span className='text-black'> {cartData.address.addressLine1}, <br></br> {cartData.address.city}</span></lable>
                                    
                                        <lable className="h7"> <span className='text-black'><br></br> {cartData.address.state}, <br></br> {cartData.address.zipcode}</span></lable>
                                    </div>
                               </>
                               
                            }
                            </div>                              
                            <div className="my-4  ">
                               <label className="h7 mt-2 p-2 "> <strong>Payment Mode :</strong><span className='text-black'> {cartData && cartData.payment.method==="E-transfer"?"Interac":cartData.payment.method==="PayPal"?"PayPal":cartData.payment.method==="Cash"?"Cash":""}</span>
                               {cartData && cartData.payment.method==="E-transfer"&&<label className="h7 mt-2 "> <strong>Interac Email :</strong><span className='text-black'>{cartData.payment.email} </span></label>
                                }
                                 {cartData && cartData.payment.method==="PayPal"&&<label className="h7 mt-2 "> <strong>PayPal Email :</strong><span className='text-black'>{cartData.payment.email} </span></label>
                                }
                                </label>
                            </div> 
                        </div>
                      
                          
            
                            {
                                total > 0 &&
                                <Button className="w-100 mt-2" variant="outline-dark rounded-lg">
                                <strong className='float-left'> Box total : </strong><strong className="float-right mr-2">${total} </strong>
                           </Button>
                            }
                            </div>
                           
                            <div className='mx-3 mt-2 d-flex justify-content-between-space' style={{fontSize:"14px"}}>
                           
                           <div class="modal fade" id="exampleModalCenter1" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
                           <div class="modal-dialog modal-dialog-centered" role="document">
                               <div class="modal-content">
                                   <div class="modal-header">
                                       <h5 class="modal-title" id="exampleModalLongTitle"></h5>
                                       <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                       <span aria-hidden="true">&times;</span>
                                       </button>
                                   </div>
                                                                 {/*Privacy policy */}  <div class="modal-body">
                                                                 <h1>Privacy Policy</h1>
                                <p><strong>Last Updated:</strong>24th March 2025</p>

                                <h2>1. Introduction</h2>
                                <p>At <strong>EPICMOVE INC.</strong> (referred to as "the Company," "we," or "us"), we operate our website and related services under the slogan: "We Buy Your Used Electronics. Simple process, immediate payments, and pickups."</p>
                                <p>This Privacy Policy outlines how we gather, store, and protect information from visitors and users ("Users" or "you") of our website. The following applies to all interactions with our website, including those on:</p>
                                <ul>
                                    <li>Our main website (including <a href="https://cash4device.ca">cash4device.ca</a> and any future domains).</li>
                                    <li>Any mobile or computer-based applications that the Company offers now or may offer in the future.</li>
                                    <li>Other services provided by the Company, as outlined on the website (collectively referred to as "the Website").</li>
                                </ul>
                                <p>By accessing or submitting any information on our Website, you agree to comply with this Policy. If you have any questions before using the Website, please reach out to us at <a href="mailto:info@cash4device.ca">info@cash4device.ca</a>.</p>

                                <h2>2. Information We Collect</h2>
                                <p>When you create an account on our Website, we collect personal information that you provide. This information is protected and will not be shared with third parties, except in accordance with this Policy or as required by law. Personal information may include, but is not limited to:</p>
                                <ul>
                                    <li>Name</li>
                                    <li>Phone Number</li>
                                    <li>Email</li>
                                    <li>Payment Information</li>
                                    <li>Address</li>
                                </ul>
                                <p>We will only use your personal information to communicate with you about your use of the Website and for purposes related to our business. We will not contact you for any unrelated commercial purposes without your consent.</p>

                                <h2>3. Uploading Information</h2>
                                <p>Users may choose to upload personal information to the Website to enhance their experience. We encourage you to upload only necessary information relevant to your use of the Website.</p>

                                <h2>4. Additional Data We Collect</h2>
                                <p>To improve the User experience, we may collect certain data automatically. This could include your IP address, device information, geolocation, system details, and other electronic interactions with our Website.</p>

                                <h2>5. Cookies</h2>
                                <p>We use cookies to enhance your Website experience and collect data about your activity. These cookies may be stored on your device, allowing us to recognize you during future visits. You can adjust your browser settings to block or notify you of cookies, but doing so may impact your ability to use some Website features.</p>

                                <h2>6. Remarketing</h2>
                                <p>We may use third-party services like Google Ads, Google Analytics, and Facebook to serve you ads after you visit our Website. These services may use minimal information about you, but we will never share your personal identifying information for remarketing purposes.</p>

                                <h2>7. Uses of Collected Data</h2>
                                <p>We use the data collected for the following purposes:</p>
                                <ul>
                                    <li>To operate and maintain the Website.</li>
                                    <li>To notify you about updates and improvements.</li>
                                    <li>To resolve technical issues.</li>
                                    <li>To monitor usage trends.</li>
                                </ul>
                                <p>We may use anonymous data for other purposes, including business analysis and Website improvements.</p>

                                <h2>8. Legal Grounds for Data Processing</h2>
                                <p>We may process your personal information based on:</p>
                                <ul>
                                    <li>A contract you have with us related to the Website.</li>
                                    <li>Your consent.</li>
                                    <li>A legal obligation.</li>
                                    <li>Our legitimate business interests, not overriding your rights.</li>
                                    <li>Payment processing.</li>
                                </ul>

                                <h2>9. Accessing, Updating & Deleting Your Information</h2>
                                <p>If you wish to view, update, or delete your personal information, contact us at <a href="mailto:info@cash4device.ca">info@cash4device.ca</a>. Requests will be processed within a reasonable timeframe, though deleting your information may result in the termination of your account.</p>
                                <p>If your account remains inactive for over a year, we may deactivate it and delete your personal data. However, we will retain necessary information as required by law.</p>

                                <h2>10. Data Security</h2>
                                <p>We store your personal data on secure servers that meet industry standards for security. While we take reasonable steps to protect your data, no system is fully secure, and we cannot guarantee complete protection.</p>

                                <h2>11. Security Breaches</h2>
                                <p>If a breach occurs that exposes your personal information, we will notify affected users promptly.</p>

                                <h2>12. Third-Party Services</h2>
                                <p>To improve the Website, we may use third-party applications, such as Google Analytics or Facebook Pixel. These services have their own privacy policies, which we encourage you to review directly.</p>

                                <h2>13. Use by Minors</h2>
                                <p>The Website is not intended for children under 13 years old, and we do not knowingly collect information from them. Children under 13 are prohibited from using the Website without parental supervision.</p>

                                <h2>14. Disclosure of Information</h2>
                                <p>In certain cases, we may need to share your personal data:</p>
                                <ul>
                                    <li>If we sell or buy assets or a business, your data may be transferred.</li>
                                    <li>If we are legally obligated to disclose your information to comply with a legal request.</li>
                                    <li>If we need to protect the rights of the Company or others.</li>
                                </ul>

                                <h2>15. Changes to This Policy</h2>
                                <p>We may update this Privacy Policy periodically. Any changes will be posted on the Website and will be effective immediately. By continuing to use the Website, you accept these updates.</p>

                                <h2>16. Contact Us</h2>
                                <p>If you have questions about this Privacy Policy, please contact us at <a href="mailto:info@cash4device.ca">info@cash4device.ca</a>. We aim to respond within 7 days.</p>

                                   </div>
                               </div>
                           </div>
                       </div>  
                           </div>
                            <div className='mx-3 mt-2 d-flex justify-content-between-space' style={{fontSize:"14px"}}>
                           
                            <div class="modal fade" id="exampleModalCenter" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
                            <div class="modal-dialog modal-dialog-centered" role="document">
                                <div class="modal-content">
                                    <div class="modal-header">
                                        <h5 class="modal-title" id="exampleModalLongTitle">Terms and conditions to sell device(s) to us</h5>
                                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                        <span aria-hidden="true">&times;</span>
                                        </button>
                                    </div>
                                                                  {/*privacy  policy*/}  
                                    <div class="modal-body">
                                                                  <h1>Terms of Use</h1>
                                                                  <p><strong>Last Updated:</strong> 24th March 2025</p>

                            <h2>1. Introduction</h2>
                            <p>These <strong>Terms of Use</strong> create a legally binding agreement between <strong>EPICMOVE INC.</strong> ("we," "us," or "our") and the individuals or companies ("Users," "Sellers," or "you") who access and use our website, <a href="https://cash4device.ca">cash4device.ca</a>, or any related platforms we control (collectively, the "Website"). These terms apply to all services, content, and products available through the Website.</p>
                            <p>It is crucial that you carefully read and fully understand these Terms of Use before using the Website. By accessing or using the Website, you agree to these terms and confirm that you have read and understood them. If you do not agree or fully understand these terms, you must not use the Website or its services.</p>
                            <p>These Terms of Use should be read alongside our <a href="/privacy">Privacy Policy</a> and any other rules or policies posted on the Website.</p>

                            <h2>2. Services Offered</h2>
                            <p>Through the Website, we provide services such as purchasing used electronics with a hassle-free process, instant payments, and pickups. To facilitate these services, <strong>EPICMOVE INC.</strong> may share limited user information with buyers to schedule pickups and complete transactions. By using our services, you consent to this sharing, which is done in compliance with our Privacy Policy.</p>
                            <p>Our services may change over time, and we do not guarantee that they will meet your specific needs or purposes.</p>

                            <h2>3. Content Ownership</h2>
                            <p>When you upload documents, images, or other data ("Content") to the Website, <strong>EPICMOVE INC.</strong> does not review or claim ownership of this Content. However, by uploading or submitting Content, you grant us a royalty-free, irrevocable license to use, copy, distribute, edit, and display the Content for business and promotional purposes while it remains on the Website.</p>

                            <h2>4. Termination</h2>
                            <p>You may stop using the Website and terminate these Terms of Use at any time by discontinuing your use of the Website.</p>

                            <h2>5. Limitation of Liability</h2>
                            <p>Except in cases where we violate these Terms of Use, we are not liable for any loss, injury, claim, or damages resulting from your use of the Website. The Website is provided "as is," and we do not guarantee that it will be error-free, secure, or uninterrupted.</p>
                            <p>In no event will we be liable for lost profits, revenues, or any indirect, special, or consequential damages, whether or not you were advised of the possibility of such damages.</p>

                            <h2>6. Indemnification</h2>
                            <p>You agree to indemnify and hold <strong>EPICMOVE INC.</strong>, its officers, directors, employees, and agents harmless from any claims, expenses, or damages arising from your use of the Website or violation of these Terms of Use.</p>

                            <h2>7. Security</h2>
                            <p>You are responsible for keeping your account credentials (usernames and passwords) secure. Notify us immediately of any unauthorized access or security breaches. While we investigate serious security issues, we are not liable for breaches or unauthorized access to your account.</p>

                            <h2>8. No Warranties</h2>
                            <p>We disclaim all warranties, whether express or implied, including warranties of merchantability or fitness for a particular purpose, as they relate to the Website.</p>

                            <h2>9. Legal Compliance</h2>
                            <p>You agree to use the Website only for lawful purposes and in compliance with all applicable laws, rules, and regulations. You also confirm that:</p>
                            <ul>
                                <li>You have the authority to agree to these Terms of Use.</li>
                                <li>Your use of the Website will not infringe on the rights of others.</li>
                                <li>You will comply with all policies posted on the Website.</li>
                            </ul>
                            <p>If you use the Website on behalf of others, you must ensure they also comply with these terms.</p>

                            <h2>10. Age Restrictions</h2>
                            <p>Users under 18 may access the Website but cannot submit personal information. Users under 13 must be supervised by a parent or guardian.</p>

                            <h2>11. Governing Law and Disputes</h2>
                            <p>These Terms of Use are governed by the laws of Ontario, Canada. Any disputes will be resolved through private, binding arbitration in Ontario, conducted by a single arbitrator. The arbitration process will follow the Arbitration Act, 1991.</p>

                            <h2>12. Class Action Waiver</h2>
                            <p>By using the Website, you agree to resolve disputes with <strong>EPICMOVE INC.</strong> individually, not as part of a class action. You waive any right to participate in class action lawsuits against us, except where prohibited by law.</p>

                            <h2>13. General Terms</h2>
                            <ul>
                                <li><strong>Amendments</strong>: We may update these Terms of Use at any time. Continued use of the Website means you accept the updated terms.</li>
                                <li><strong>Assignment</strong>: We may assign these terms without your consent, but you may not assign them without our written approval.</li>
                                <li><strong>No Waiver</strong>: Failure to enforce a provision does not waive it.</li>
                                <li><strong>No Agency</strong>: We are independent contractors, not partners or agents.</li>
                                <li><strong>Severability</strong>: If any part of these terms is invalid, the rest remains in effect.</li>
                                <li><strong>Entire Agreement</strong>: These terms, along with our Privacy Policy and other policies, constitute the entire agreement between you and <strong>EPICMOVE INC.</strong></li>
                            </ul>

                            <h2>14. Contact Us</h2>
                            <p>For questions about these Terms of Use, contact us at <a href="mailto:info@cash4device.ca">info@cash4device.ca</a>.</p>

                            <h2>15. Data Security Responsibilities</h2>
                            <ul>
                                <li><strong>User Responsibility</strong>: You must factory reset or wipe all personal data from your devices before selling them. If you need help, <strong>EPICMOVE INC.</strong> can assist, but we are not responsible for damage or data loss during this process.</li>
                                <li><strong>Liability</strong>: We are not liable for data breaches, device damage, or privacy issues resulting from incomplete data erasure. Once a sale is finalized, devices are non-returnable.</li>
                                <li><strong>Indemnification</strong>: You agree to indemnify <strong>EPICMOVE INC.</strong> for any claims arising from your failure to erase data or requests to return devices after sale.</li>
                            </ul>

                            <h2>16. Pickup Process</h2>
                            <p>For details on the pickup process, including eligibility and transaction finalization, refer to our guide: <a href="/Support/Faq/Same_day_pickup"> same day pickup  for customer located in GTA </a>.</p>

                            
                            <ul>
                                <li><strong>Packaging</strong>: You are responsible for securely packaging devices to prevent damage during shipping. We are not liable for damage caused by inadequate packaging.</li>
                                <li><strong>Factory Reset</strong>: Devices must be factory reset before shipping. If not, we will reset them and delete all data as part of our testing process. We are not responsible for data loss.</li>
                                <li><strong>Prohibited Devices</strong>: We do not accept blacklisted, stolen, or locked devices. These will be returned at your expense.</li>
                                <li><strong>Shipping Guide</strong>: For more information, visit our <a href="/Support/Faq/Shipping_Label_Procedure">Shipping Label/QR code Process Works</a> page.</li>
                            </ul>

                            <h2>18. Drop-Off Process</h2>
                            <ul>
                                <li><strong>Data Erasure</strong>: You must factory reset devices before drop-off. If not, we will reset them and are not responsible for data loss.</li>
                                <li><strong>Assistance</strong>: If you need help with data erasure, we can assist during drop-off, but we are not liable for damage or data loss.</li>
                                <li><strong>Drop-Off Guide</strong>: For more details, visit our <a href="/Support/Faq/Drop_Off_Procedure">Our drop-off procedure</a> page.</li>
                            </ul>

                            <h2>19. Right to Refuse Purchases</h2>
                            <p>We reserve the right to refuse the purchase of devices under certain conditions. Refer to our <a href="/Support/Faq/Device_Can_Sell">Which types of Devices Can I Sell?</a> page for details.</p>

                            <h2>20. Additional Data Erasure Requirements</h2>
                            <ul>
                                <li><strong>Data Erasure</strong>: You must reset devices before drop-off/shipping and remove any SIM CARD and/or memory storage card/SD card. If not, we will reset and remove them and are not responsible for data loss or any kind of loss or/and damages arising from it.</li>
                                <li><strong>Assistance</strong>: We can help with data erasure during drop-off/shiipping but are not liable for damage or data loss.</li>
                            </ul>

                            <h2>21. Unresponsive Sellers</h2>
                            <p>If you send a device to us and we require additional information, you must respond within specified timeframe mentioned in our communication to you. If you do not, the device will be recycled  without compensation or return except in the situation of revised offer due to condition mismatch.</p>
                            <p>In the situation of revised offer due to condition mismatch, we would wait for 5 business day for you to either accept the revised offer or decline and request to return the device(s) at the cost of nominal shipping fee</p>
                            
                            <h2>22. Disagreement about the cosmetic condition of the device(s) between you and <strong>EPICMOVE INC.(cash4device.ca)</strong></h2>
                            <p>We understand that you have thoroughly check your device(s) to determine which cosmetic condition  are they in. However it may differ in some cases once we received your device or our associate comes to your for pickup and we perform on the spot inspection or inspection after we received them and found out that cosmetic condition</p>
                            <p>of device(s) are not what you have determined upon initial observation and submitted online on our website cash4device.ca, in this situation,  we need to revised your offer based upon the actual cosmetic condition that our team have determined on the basis of our standard inspection process.</p>
                            <p>In this scenario, you can go ahead and accept the new offer based on the cosmetic condition our inspecton team or assocciate have determined or decline to accept and request to return your device back to you if you have shipped your device to us, we would love to send device(s) back to you at nominal return shipping fee.</p>


                                <h2 >23.Same day pickup service</h2>
                                <p>In most cases, we can schedule same day pickup of your device(s) from the address you provided online while checking out. Same day pickup services are available in these following cities of the GTA.</p>
                                <ul>
                                    <li>Ajax</li>
                                    <li>Brampton</li>
                                    <li>Etobicoke</li>
                                    <li> Markham</li>
                                    <li>Mississauga</li>
                                    <li>Oshawa</li>
                                    <li>Pickering</li>
                                    <li>Richmond Hill</li>
                                    <li>Toronto(Including Scarborough, North York, East York, Thorn cliff etc..)</li>
                                    <li>Vaughan</li>
                                    <li>Whitby</li>
                                </ul>

                                    <p>Please note: Once we received your submission our associate will contact your as per his earliest convenience to schedule meeting with you either by email or by phone as per your availability and his other appointments schedule. </p>
                                    
                                    <p>If you’re located outside of these cities, Kindly ship your device(s) to us, we offer express shipping for free, which will deliver your device(s) to us in 1-3 business day and we pay immediately upon receiving of your device once we finished wit our process which won’t take longer than 30 min for single device.</p>
                                    
                                <h2>24. Agreement Confirmation</h2>
                            <p>By using <a href="https://cash4device.ca">cash4device.ca</a>, you confirm that you have read, understood, and agreed to these Terms of Use, including our data security policies and the requirement to erase personal data before selling devices.</p>
        </div>
            </div>
            </div>
                        </div>  
                            </div>
                             <div className=''>
                             <p  style={{fontSize: "15px", fontWeight:600, padding:"10px"}}>Please carefully read our<a type="link" data-toggle="modal" data-target="#exampleModalCenter"> 
                            <span className="text-info cursor-pointer"> Terms & Conditions </span></a>and<a type="link" data-toggle="modal" data-target="#exampleModalCenter1"> 
                            <span className="text-info cursor-pointer"> Privacy Policy</span></a> before placing your order.</p>    
                                <div className="mx-1 mb-2 p-2"role="group" aria-labelledby="checkbox-group">
                           
                                <div className='d-flex '>
                                <Field type="checkbox" name="tandc"  id="tandc"/>
                                <span style={{fontSize: "15px", fontWeight:600, marginLeft:"7px"}}>   I Accept the terms & conditions and privacy policy.</span>
                                </div>
                                
                                <ErrorMessage name="tandc" className="text-danger" component="div" />
                             </div>
                            
                           
                            {/*<lable>
                                two
                                <input type="checkbox" onChange={handleChange}/>
                            </lable>
                            <label>
                                three
                            <input type="checkbox" onChange={handleChange}/>
                            </label>*/}
                            
                        </div>
                       
                        {isLoader && 
                        <div className="text-center">
                            <LoaderSpinner></LoaderSpinner>
                        </div>
            
    
                        }

                            <div className="mt-4 d-flex mb-4" ref={section1Ref}>
                                <Button className="w-100 bg-warning border-dark  mb-2" onClick={previousPage} variant=" ml-2" disabled={isSubmitting}><span style={{fontSize:20, fontWeight:800}}>Previous</span></Button>
                                <Button className="w-100 bg-warning border-dark ml-4 mb-2" type="submit" variant=" ml-4" disabled={isSubmitting}>
                                    {total <= 0 && <span style={{fontSize:20, fontWeight:800}}>Recycle</span>} {total > 0 && <span style={{fontSize:20, fontWeight:800}}>Checkout</span>}
                                </Button>
                            </div>
                        
                    </Form>
                )}
                
            </Formik>
            
        
            </div>
            </div >

        
       
        </div>
        </div>
    )
    
}

const mapStateToProps = state => {
    return {
        paymentMethod: state.cart.payment,
        items: state.cart.items,
        token: state.auth.token,
        address: state.cart.address,
        totalPayment: state.cart.totalPayment
    }
}

const mapDispatchToProps = dispatch => {
    return {
        addPayment: (value) => dispatch(actions.updateCartPayment(value)),
        clearCart: (username, password) => dispatch(actions.clearCartItem())

    }
}

export default connect(mapStateToProps, mapDispatchToProps)(CheckOutPage);
